<template>
  <div class="noiseRecorder">
    <div class="header">
      <div class="header-left">
        <img src="../../assets/noise/logo.png" class="icon" />
        <span>漏水监测仪管理平台</span>
      </div>
      <div class="btn-box">
        <el-button size="mini" @click="toLogin">登录</el-button>
        <el-button type="primary" size="mini" @click="toRgister">立即注册</el-button>
      </div>
    </div>
    <div class="banner">
      <img src="../../assets/noise/banner.jpg" class="icon" />
      <div class="banner-titler">
        <h1>智能管道漏水监测仪</h1>
        <p>采集管网泄漏音频数据，为快速确定漏水点位置提供可靠的分析依据</p>
      </div>
    </div>
    <div class="device-box">
      <div class="titer-box">
        <h2>设备介绍</h2>
        <p>精准泄漏检测、快速定位漏水点</p>
      </div>
      <div class="device-group-name">
        <span>单漏水监测仪DX-20A</span>
        <div class="status">底部磁吸</div>
        <div class="status green">口径无要求</div>
      </div>
      <div class="device-group">
        <div class="device-list" v-for="item in deviceList" :key="item.bg">
          <div class="right-img" :style="'background-image:url(' + item.bg + ');'"></div>
          <div class="device-list-name">{{ item.name }}</div>
          <div class="device-list-desc-box">
            <div class="device-list-desc" v-for="(l, i) in item.list" :key="i">
              <div class="label">{{ l.label }}</div>
              <div class="value">{{ l.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="equ-advant">
      <div class="titer-box">
        <h2>设备优势与价值</h2>
        <p>为用户提供持久、精准、省心的噪声监测解决方案</p>
      </div>
      <div class="equ-info">
        <div class="equ-list left1">
          <div class="sort">01</div>
          <div class="name">超长续航</div>
          <div class="desc">高效能电池系统，续航6年+，寿命达普通产品2-3倍</div>
        </div>
        <div class="equ-list left2">
          <div class="sort">02</div>
          <div class="name">快换维护</div>
          <div class="desc">模块化设计支持快速更换，降低维护成本</div>
        </div>
        <div class="equ-list right1">
          <div class="sort">03</div>
          <div class="name">智能采集</div>
          <div class="desc">三模系统+四种采集模式，适配多场景需求</div>
        </div>
        <div class="equ-list right2">
          <div class="sort">04</div>
          <div class="name">高性能采集</div>
          <div class="desc">宽频带信号覆盖(4000Hz-16000Hz),采集时长1-15秒可调</div>
        </div>
        <div class="equ-list center">
          <div class="sort">05</div>
          <div class="name">极简操作</div>
          <div class="desc">一键切换预设方案或自定义触发策略，实现“安装即忘”免维护体验</div>
        </div>
      </div>
    </div>
    <div class="device-box">
      <div class="titer-box">
        <h2>平台特点</h2>
        <p>智能联动、精准预警、闭环管理，让噪声监测更省心</p>
      </div>
      <div class="plot-group">
        <div class="plot-item" v-for="(item, index) in plotList" :key="index">
          <div class="tip">{{ item.tip }}</div>
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="device-box">
      <div class="titer-box">
        <h2>AI模型算法优势</h2>
        <p>高精度、快响应，让漏损检测更智能高效</p>
      </div>
      <div class="ai-group">
        <div
          class="ai-item"
          v-for="(item, index) in aiList"
          :key="index"
          :style="'background-image:url(' + item.bg + ');background-color:' + item.color"
        >
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="device-box">
      <div class="titer-box">
        <h2>应用场景</h2>
        <p>无破坏安装、噪声模式AI诊断</p>
      </div>
      <div class="address-group">
        <div class="address-item" v-for="(item, index) in addressList" :key="index">
          <div class="img" :style="'background-image:url(' + item.url + ');'"></div>
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      Copyright © 1996 - {{ yearNum }} 漏水监测仪管理平台
      <a href="http://beian.miit.gov.cn" target="_blank" style="color: #fff" class="copyright"
        >粤ICP备17066176号-2</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'noiseRecorder',
  data() {
    return {
      yearNum: new Date().getFullYear(),
      deviceList: [
        {
          name: '传感器特性',
          bg: require('../../assets/noise/bg1.png'),
          list: [
            {
              label: '类型',
              value: '压电陶瓷'
            },
            {
              label: '电容率',
              value: '580CtpF'
            },
            {
              label: '谐振频率',
              value: '116kHz'
            },
            {
              label: '耦合系数',
              value: '60Kp(%)'
            },
            {
              label: '品质因数',
              value: '1000Qm'
            }
          ]
        },
        {
          name: '环境适应性',
          bg: require('../../assets/noise/bg2.png'),
          list: [
            {
              label: '防护等级',
              value: 'IP67、IP68可选'
            },
            {
              label: '介质温度',
              value: '0 ～ +130℃'
            },
            {
              label: '环境温度',
              value: '-25 ～ +65℃'
            },
            {
              label: '储存温度',
              value: '-40 ～ +70℃'
            },
            {
              label: '外壳材料',
              value: '不锈钢'
            }
          ]
        },
        {
          name: '测量功能',
          bg: require('../../assets/noise/bg3.png'),
          list: [
            {
              label: '测量参数',
              value: '噪声音频、噪声强度、噪声频率'
            },
            {
              label: '采集频率',
              value: '4000Hz ~ 16000Hz'
            },
            {
              label: '采集时长',
              value: '1秒 ~ 15秒'
            },
            {
              label: '采集模式',
              value: '关闭、巡检、警戒、哨兵'
            }
          ]
        },
        {
          name: '通信与数据管理',
          bg: require('../../assets/noise/bg4.png'),
          list: [
            {
              label: '远端通讯',
              value: '4G'
            },
            {
              label: 'GPS定位',
              value: '有'
            },
            {
              label: '蓝牙功能',
              value: '有'
            },
            {
              label: '存储功能',
              value: '7条历史音频'
            },
            {
              label: '远程升级',
              value: '有'
            }
          ]
        }
      ],
      plotList: [
        {
          name: '双端联动',
          desc: 'Web端+小程序端无缝协同，随时随地监控设备与数据。',
          tip: '高效协同'
        },
        {
          name: '智能预警，报警规则可配',
          desc: 'AI智能分析 + 人工分析，降低误报率。',
          tip: '精准可靠'
        },
        {
          name: '报警规则可配',
          desc: '自定义报警规则，灵活适配不同场景需求。',
          tip: '灵活配置'
        },
        {
          name: '全流程闭环管理',
          desc: '从设备注册 → 激活 → 报警 → 漏点定位 → 维修跟踪实现全流程闭环管理',
          tip: '问题可追溯'
        }
      ],
      aiList: [
        {
          name: 'CNN-Transformer融合模型',
          desc: 'CNN提取局部声纹特征 +Transformer捕捉全局时序依赖，实现多尺度特征融合',
          bg: require('../../assets/noise/a-bg1.png'),
          color: '#FFF3E0'
        },
        {
          name: '高精度识别',
          desc: '复杂噪声环境下，泄漏模式识别准确率显著提升（AUC > 0.9）',
          bg: require('../../assets/noise/a-bg2.png'),
          color: '#E7F7ED'
        },
        {
          name: '轻量化边缘计算',
          desc: '秒级响应（推理耗时 <1s），快速定位泄漏点，支持实时检测',
          bg: require('../../assets/noise/a-bg3.png'),
          color: '#E6EFFE'
        }
      ],
      addressList: [
        {
          url: require('../../assets/noise/c-bg1.jpg'),
          name: '市政供热管网漏水监测',
          desc: '供热期间持续工作，及时发现漏水迹象，且可通过多个漏水监测仪组成的监测网络，结合AI 算法识别漏水点大致位置'
        },
        {
          url: require('../../assets/noise/c-bg2.jpg'),
          name: '市政供水管网漏水监测',
          desc: '无需破坏管网结构，长期对主干管、支线及入户管的多层级覆盖监控，及时上传管道漏水噪声数据，通过AI算法识别漏水点大致位置'
        },
        {
          url: require('../../assets/noise/c-bg3.jpg'),
          name: 'DMA供水管道监测',
          desc: '安装在管网节点与区域监控表构成立体监测矩阵，实现区域异常供水全方位监控，结合AI算法识别漏水点大致位置'
        }
      ]
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    toRgister() {
      this.$router.push({
        path: '/registerNow'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
